<template>
  <div class="profit-rule-page">
    <!-- 页面标题 -->
    <page-header>
      <div>分润规则管理</div>
    </page-header>

    <!-- 搜索和操作区域 -->
    <div class="operation-area">
      <el-row :gutter="20">
        <el-col :span="8">
          <!-- 顶部搜索：改为「选择店铺」按钮 + 已选展示 -->
          <div class="merchant-picker">
            <el-input
                :value="searchMerchantName"
                placeholder="请选择店铺"
                readonly
                @click.native="openMerchantPicker('search')"
                style="width: 100%; cursor: pointer;"
            >
              <i slot="suffix" class="el-icon-search" style="cursor: pointer;" @click="openMerchantPicker('search')"></i>
            </el-input>
            <el-button
                v-if="searchMerchantId"
                type="text"
                style="margin-left: 8px;"
                @click="clearSearchMerchant"
            >清除</el-button>
          </div>
        </el-col>
        <el-col :span="16" class="text-right">
          <el-button type="primary" @click="handleAdd">
            <i class="el-icon-plus"></i> 新增规则
          </el-button>
          <el-button type="success" @click="handleAddDefault">
            <i class="el-icon-setting"></i> 设置默认规则
          </el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 规则列表 -->
    <el-card class="list-card">
      <div slot="header">
        <span><i class="el-icon-document"></i> 分润规则列表</span>
        <el-button size="small" style="float:right;" @click="loadData">
          <i class="el-icon-refresh"></i> 刷新
        </el-button>
      </div>

      <div v-loading="loading">
        <el-table :data="tableData.list" border stripe>
          <el-table-column label="ID" prop="id" width="70" align="center" />
          <el-table-column label="店铺名称" min-width="150">
            <template slot-scope="{ row }">
              {{ row.merchantName || '全局默认' }}
              <el-tag v-if="!row.merchantId" type="warning" size="mini" style="margin-left:8px;">默认</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="关联代理" width="120" align="center">
            <template slot-scope="{ row }">
              {{ row.agentName || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="规则名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ row.ruleName }}
            </template>
          </el-table-column>
          <el-table-column label="手续费率" width="100" align="center">
            <template slot-scope="{ row }">
              {{ row.merchantFeeRate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column label="平台" width="80" align="center">
            <template slot-scope="{ row }">
              {{ row.platformRate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column label="商家" width="80" align="center">
            <template slot-scope="{ row }">
              {{ row.merchantRate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column label="员工" width="80" align="center">
            <template slot-scope="{ row }">
              {{ row.clerkRate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column label="用户" width="80" align="center">
            <template slot-scope="{ row }">
              {{ row.userRate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column label="代理" width="80" align="center">
            <template slot-scope="{ row }">
              {{ row.agentRate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column label="分润类型" width="100" align="center">
            <template slot-scope="{ row }">
              {{ row.profitType === 1 ? '线上购券' : '线下扫码' }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="row.valid ? 'success' : 'danger'" size="mini">
                {{ row.valid ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
              <el-button type="text" size="mini" @click="handleToggleStatus(row)" :style="{color: row.valid ? '#E6A23C' : '#67C23A'}">
                {{ row.valid ? '禁用' : '启用' }}
              </el-button>
              <el-button type="text" size="mini" style="color:#f56c6c;" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-empty v-if="!loading && tableData.list.length === 0" description="暂无分润规则" :image-size="120">
          <el-button type="primary" @click="handleAdd">添加第一条规则</el-button>
        </el-empty>

        <!-- 分页 -->
        <div class="pagination-container" v-if="tableData.list.length > 0">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="tableData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
              background
          />
        </div>
      </div>
    </el-card>

    <!-- ==================== 编辑弹窗 ==================== -->
    <el-dialog
        :visible.sync="dialogVisible"
        :title="dialogTitle"
        width="650px"
        @close="handleDialogClose"
        append-to-body
        :close-on-click-modal="false"
    >
      <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
      >
        <!-- 店铺选择（改为点击弹窗选择） -->
        <el-form-item label="关联店铺" prop="merchantId">
          <div style="display:flex; align-items:center;">
            <el-input
                :value="ruleForm.merchantName"
                placeholder="请选择店铺（不选则为全局默认）"
                readonly
                @click.native="openMerchantPicker('form')"
                style="flex:1; cursor: pointer;"
            >
              <i slot="suffix" class="el-icon-search" style="cursor: pointer;" @click="openMerchantPicker('form')"></i>
            </el-input>
            <el-button
                v-if="ruleForm.merchantId"
                type="text"
                style="margin-left: 8px;"
                @click="clearFormMerchant"
            >清除</el-button>
          </div>
          <div class="form-tip" style="color:#E6A23C;font-size:12px;">
            <i class="el-icon-info"></i>
            不选择店铺则为全局默认规则，所有店铺共用
          </div>
        </el-form-item>

        <!-- 关联代理（自动显示） -->
        <el-form-item label="关联代理">
          <el-input
              :value="ruleForm.agentName || '暂无关联代理'"
              disabled
              style="width: 100%;"
          />
          <div class="form-tip" style="color:#409EFF;font-size:12px;">
            <i class="el-icon-info"></i>
            系统根据店铺自动反查代理
          </div>
        </el-form-item>

        <!-- 规则名称 -->
        <el-form-item label="规则名称" prop="ruleName" required>
          <el-input v-model="ruleForm.ruleName" placeholder="请输入规则名称" maxlength="100" style="width: 100%;" />
        </el-form-item>

        <!-- 分润类型 -->
        <el-form-item label="分润类型" prop="profitType" required>
          <el-radio-group v-model="ruleForm.profitType">
            <el-radio :label="1">线上购券</el-radio>
            <el-radio :label="2">线下扫码</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 分割线 -->
        <el-divider content-position="center">分润比例配置</el-divider>

        <!-- 手续费率 -->
        <el-form-item label="手续费率" prop="merchantFeeRate" required>
          <el-input-number
              v-model="ruleForm.merchantFeeRate"
              :min="0"
              :max="100"
              :step="1"
              controls-position="right"
              style="width: 200px;"
          />
          <span class="form-unit">%</span>
          <div class="form-tip" style="color:#999;font-size:12px;">
            从订单总金额中抽取的比例
          </div>
        </el-form-item>

        <!-- 分润比例 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="平台分润" prop="platformRate" required>
              <el-input-number
                  v-model="ruleForm.platformRate"
                  :min="0"
                  :max="100"
                  :step="1"
                  controls-position="right"
                  style="width: 160px;"
              />
              <span class="form-unit">%</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商家分润" prop="merchantRate" required>
              <el-input-number
                  v-model="ruleForm.merchantRate"
                  :min="0"
                  :max="100"
                  :step="1"
                  controls-position="right"
                  style="width: 160px;"
              />
              <span class="form-unit">%</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="员工分润" prop="clerkRate" required>
              <el-input-number
                  v-model="ruleForm.clerkRate"
                  :min="0"
                  :max="100"
                  :step="1"
                  controls-position="right"
                  style="width: 160px;"
              />
              <span class="form-unit">%</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户返利" prop="userRate" required>
              <el-input-number
                  v-model="ruleForm.userRate"
                  :min="0"
                  :max="100"
                  :step="1"
                  controls-position="right"
                  style="width: 160px;"
              />
              <span class="form-unit">%</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="代理分润" prop="agentRate" required>
          <el-input-number
              v-model="ruleForm.agentRate"
              :min="0"
              :max="100"
              :step="1"
              controls-position="right"
              style="width: 160px;"
          />
          <span class="form-unit">%</span>
        </el-form-item>

        <!-- 合计验证 -->
        <el-form-item label="合计验证">
          <div :style="{color: isRatioValid ? '#67C23A' : '#F56C6C', fontWeight: 'bold'}">
            {{ getTotalRatio() }}%
            <span v-if="isRatioValid" style="margin-left:10px;font-size:14px;">✅ 合计正确</span>
            <span v-else style="margin-left:10px;font-size:14px;">❌ 合计必须等于100%</span>
          </div>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input
              v-model="ruleForm.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              maxlength="500"
              show-word-limit
              style="width: 100%;"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <div class="footer-left">
          <el-tag :type="ruleForm.id ? 'success' : 'info'" size="medium">
            {{ ruleForm.id ? '编辑规则' : '新增规则' }}
          </el-tag>
        </div>
        <div>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">
            {{ ruleForm.id ? '更新' : '保存' }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- ==================== 店铺选择弹窗 ==================== -->
    <el-dialog
        :visible.sync="merchantPickerVisible"
        title="选择店铺"
        width="800px"
        append-to-body
        :close-on-click-modal="false"
        @close="handlePickerClose"
    >
      <!-- 搜索 -->
      <div style="margin-bottom: 16px;">
        <el-input
            v-model="pickerKeyword"
            placeholder="输入店铺名称搜索"
            clearable
            style="width: 300px;"
            @keyup.enter.native="handlePickerSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handlePickerSearch">搜索</el-button>
        </el-input>
      </div>

      <!-- 表格 -->
      <el-table
          :data="pickerList"
          v-loading="pickerLoading"
          border
          stripe
          height="400"
          highlight-current-row
          @current-change="handlePickerRowChange"
      >
        <el-table-column label="店铺ID" prop="id" width="100" align="center" />
        <el-table-column label="店铺名称" prop="name" min-width="200" show-overflow-tooltip />
        <el-table-column label="图片" width="100" align="center">
          <template slot-scope="{ row }">
            <el-image
                v-if="row.image"
                :src="row.image"
                style="width: 40px; height: 40px; border-radius: 4px;"
                fit="cover"
                :preview-src-list="[row.image]"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="confirmPick(row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container" style="margin-top: 16px;">
        <el-pagination
            @size-change="handlePickerSizeChange"
            @current-change="handlePickerPageChange"
            :current-page="pickerPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pickerPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pickerTotal"
            background
        />
      </div>

      <div slot="footer">
        <el-button @click="merchantPickerVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!pickerSelected" @click="confirmPick(pickerSelected)">
          确定选择
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import api from "@/utils/api";

export default {
  name: 'ProfitRuleList',
  components: { PageHeader },
  data() {
    return {
      loading: false,
      submitting: false,

      // ===== 顶部搜索：店铺 =====
      searchMerchantId: null,
      searchMerchantName: '',

      // ===== 店铺选择弹窗 =====
      merchantPickerVisible: false,
      merchantPickerSource: '',     // 'search' | 'form'，标记从哪打开的
      pickerKeyword: '',
      pickerList: [],
      pickerLoading: false,
      pickerPage: 1,
      pickerPageSize: 10,
      pickerTotal: 0,
      pickerSelected: null,         // 当前选中的行

      // ===== 分润规则列表 =====
      tableData: {
        list: [],
        total: 0,
        page: 1,
        pageSize: 10
      },

      dialogVisible: false,
      dialogTitle: '新增分润规则',

      ruleForm: {
        id: null,
        merchantId: null,
        merchantName: '',
        agentName: '',
        ruleName: '',
        profitType: 2,
        merchantFeeRate: 0,
        platformRate: 20,
        merchantRate: 15,
        clerkRate: 9,
        userRate: 50,
        agentRate: 6,
        remark: ''
      },

      rules: {
        ruleName: [
          { required: true, message: '请输入规则名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        profitType: [
          { required: true, message: '请选择分润类型', trigger: 'change' }
        ],
        merchantFeeRate: [
          { required: true, message: '请输入手续费率', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '手续费率必须在0-100之间', trigger: 'blur' }
        ],
        platformRate: [
          { required: true, message: '请输入平台分润', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分润比例必须在0-100之间', trigger: 'blur' }
        ],
        merchantRate: [
          { required: true, message: '请输入商家分润', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分润比例必须在0-100之间', trigger: 'blur' }
        ],
        clerkRate: [
          { required: true, message: '请输入员工分润', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分润比例必须在0-100之间', trigger: 'blur' }
        ],
        userRate: [
          { required: true, message: '请输入用户返利', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分润比例必须在0-100之间', trigger: 'blur' }
        ],
        agentRate: [
          { required: true, message: '请输入代理分润', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '分润比例必须在0-100之间', trigger: 'blur' }
        ]
      }
    };
  },

  computed: {
    isRatioValid() {
      return this.getTotalRatio() === 100;
    }
  },

  methods: {
    getTotalRatio() {
      const { platformRate, merchantRate, clerkRate, userRate, agentRate } = this.ruleForm;
      return (platformRate || 0) + (merchantRate || 0) + (clerkRate || 0) + (userRate || 0) + (agentRate || 0);
    },

    // ==================== 店铺选择弹窗 ====================

    openMerchantPicker(source) {
      console.log('[店铺弹窗] 打开，来源:', source);
      this.merchantPickerSource = source;
      this.pickerKeyword = '';
      this.pickerPage = 1;
      this.pickerSelected = null;
      this.merchantPickerVisible = true;
      this.loadPickerList();
    },

    async loadPickerList() {
      this.pickerLoading = true;
      try {
        const params = {
          page: this.pickerPage,
          pageSize: this.pickerPageSize
        };
        // 如果后端支持按名称搜索，加上 name 参数
        if (this.pickerKeyword) {
          params.name = this.pickerKeyword;
        }
        console.log('[店铺弹窗] 请求参数:', params);

        const res = await api.merchant_getMerchantList(params);
        console.log('[店铺弹窗] 接口返回:', res);

        if (res.data.code === '000' && res.data.data) {
          this.pickerList = res.data.data.list || [];
          this.pickerTotal = res.data.data.totalCount || 0;
        }
      } catch (error) {
        console.error('[店铺弹窗] 加载失败:', error);
        this.$message.error('加载店铺失败');
      } finally {
        this.pickerLoading = false;
      }
    },

    handlePickerSearch() {
      this.pickerPage = 1;
      this.loadPickerList();
    },

    handlePickerSizeChange(size) {
      this.pickerPageSize = size;
      this.pickerPage = 1;
      this.loadPickerList();
    },

    handlePickerPageChange(page) {
      this.pickerPage = page;
      this.loadPickerList();
    },

    handlePickerRowChange(row) {
      this.pickerSelected = row;
    },

    confirmPick(row) {
      if (!row) {
        this.$message.warning('请先选择店铺');
        return;
      }
      console.log('[店铺弹窗] 确认选择:', row);

      if (this.merchantPickerSource === 'search') {
        this.searchMerchantId = row.id;
        this.searchMerchantName = row.name;
        this.handleSearch();
      } else if (this.merchantPickerSource === 'form') {
        this.ruleForm.merchantId = row.id;
        this.ruleForm.merchantName = row.name;
        this.handleMerchantChange(row.id);
      }

      this.merchantPickerVisible = false;
    },

    handlePickerClose() {
      this.pickerSelected = null;
      this.pickerKeyword = '';
    },

    clearSearchMerchant() {
      this.searchMerchantId = null;
      this.searchMerchantName = '';
      this.handleSearch();
    },

    clearFormMerchant() {
      this.ruleForm.merchantId = null;
      this.ruleForm.merchantName = '';
      this.ruleForm.agentName = '';
    },

    // ==================== 分润规则列表 ====================

    async loadData() {
      this.loading = true;
      try {
        const params = {
          page: this.tableData.page,
          pageSize: this.tableData.pageSize,
          merchantId: this.searchMerchantId || undefined
        };
        console.log('[规则列表] 请求参数:', params);

        const res = await api.profitRule_getList(params);
        console.log('[规则列表] 接口返回:', res);

        if (res.data.code === '000' && res.data.data) {
          const data = res.data.data;
          this.tableData.list = data.list || [];
          this.tableData.total = data.totalCount || 0;
        }
      } catch (error) {
        console.error('加载分润规则失败:', error);
        this.$message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.tableData.page = 1;
      this.loadData();
    },

    handleSizeChange(size) {
      this.tableData.pageSize = size;
      this.tableData.page = 1;
      this.loadData();
    },

    handleCurrentChange(page) {
      this.tableData.page = page;
      this.loadData();
    },

    // ==================== 新增 / 编辑 ====================

    handleAdd() {
      this.resetForm();
      this.dialogTitle = '新增分润规则';
      this.dialogVisible = true;
    },

    handleAddDefault() {
      this.resetForm();
      this.ruleForm.merchantId = null;
      this.ruleForm.merchantName = '';
      this.ruleForm.ruleName = '全局默认分润规则';
      this.ruleForm.profitType = 2;
      this.ruleForm.platformRate = 20;
      this.ruleForm.merchantRate = 15;
      this.ruleForm.clerkRate = 9;
      this.ruleForm.userRate = 50;
      this.ruleForm.agentRate = 6;
      this.dialogTitle = '设置全局默认规则';
      this.dialogVisible = true;
    },

    handleEdit(row) {
      console.log('[编辑] 当前行:', row);
      this.ruleForm = {
        id: row.id,
        merchantId: row.merchantId || null,
        merchantName: row.merchantName || '',
        agentName: row.agentName || '',
        ruleName: row.ruleName || '',
        profitType: row.profitType || 2,
        merchantFeeRate: row.merchantFeeRate || 0,
        platformRate: row.platformRate || 0,
        merchantRate: row.merchantRate || 0,
        clerkRate: row.clerkRate || 0,
        userRate: row.userRate || 0,
        agentRate: row.agentRate || 0,
        remark: row.remark || ''
      };
      this.dialogTitle = '编辑分润规则';
      this.dialogVisible = true;

      if (row.merchantId) {
        this.loadAgentInfo(row.merchantId);
      }
    },

    async handleToggleStatus(row) {
      const action = row.valid ? '禁用' : '启用';
      try {
        await this.$confirm(`确定要${action}规则 "${row.ruleName}" 吗？`, '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
        const res = await api.profitRule_toggleStatus({ id: row.id });
        if (res.data.code === '000') {
          this.$message.success(`${action}成功`);
          this.loadData();
        } else {
          this.$message.error(res.data.message || '操作失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('切换状态失败:', error);
          this.$message.error('操作失败');
        }
      }
    },

    async handleMerchantChange(merchantId) {
      console.log('[弹窗表单] 选中店铺ID:', merchantId);
      this.ruleForm.agentName = '';
      if (merchantId) {
        await this.loadAgentInfo(merchantId);
      }
    },

    async loadAgentInfo(merchantId) {
      try {
        const res = await api.profitRule_getAgentByMerchantId({ merchantId });
        if (res.data.code === '000' && res.data.data) {
          this.ruleForm.agentName = res.data.data.agentName || '暂无关联代理';
        }
      } catch (error) {
        console.error('查询代理信息失败:', error);
        this.ruleForm.agentName = '查询失败';
      }
    },

    handleSubmit() {
      this.$refs.ruleFormRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请检查表单必填项');
          return;
        }

        if (!this.isRatioValid) {
          this.$message.error('分润比例合计必须等于100%，当前合计：' + this.getTotalRatio() + '%');
          return;
        }

        this.submitting = true;
        try {
          const data = {
            id: this.ruleForm.id || undefined,
            merchantId: this.ruleForm.merchantId || null,
            ruleName: this.ruleForm.ruleName,
            profitType: this.ruleForm.profitType,
            merchantFeeRate: this.ruleForm.merchantFeeRate || 0,
            platformRate: this.ruleForm.platformRate || 0,
            merchantRate: this.ruleForm.merchantRate || 0,
            clerkRate: this.ruleForm.clerkRate || 0,
            userRate: this.ruleForm.userRate || 0,
            agentRate: this.ruleForm.agentRate || 0,
            remark: this.ruleForm.remark
          };
          console.log('[提交] 提交数据:', data);

          const res = await api.profitRule_save(data);
          if (res.data.code === '000') {
            this.$message.success(this.ruleForm.id ? '更新成功' : '保存成功');
            this.dialogVisible = false;
            this.loadData();
          } else {
            this.$message.error(res.data.message || '操作失败');
          }
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('操作失败');
        } finally {
          this.submitting = false;
        }
      });
    },

    handleDelete(row) {
      this.$confirm(`确定要删除规则 "${row.ruleName}" 吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      }).then(async () => {
        try {
          const res = await api.profitRule_delete({ id: row.id });
          if (res.data.code === '000') {
            this.$message.success('删除成功');
            this.loadData();
          } else {
            this.$message.error(res.data.message || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }).catch(() => {});
    },

    resetForm() {
      this.ruleForm = {
        id: null,
        merchantId: null,
        merchantName: '',
        agentName: '',
        ruleName: '',
        profitType: 2,
        merchantFeeRate: 0,
        platformRate: 20,
        merchantRate: 15,
        clerkRate: 9,
        userRate: 50,
        agentRate: 6,
        remark: ''
      };
      this.$refs.ruleFormRef?.resetFields();
    },

    handleDialogClose() {
      this.$refs.ruleFormRef?.resetFields();
    }
  },

  mounted() {
    console.log('========== 页面加载 ==========');
    this.loadData();
  }
}
</script>

<style scoped>
.profit-rule-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.operation-area {
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.text-right {
  text-align: right;
}

.list-card {
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.form-unit {
  margin-left: 8px;
  font-size: 14px;
  color: #666;
}

.form-tip {
  margin-top: 4px;
  line-height: 1.5;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-left {
  display: flex;
  align-items: center;
}

.merchant-picker {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .operation-area {
    padding: 16px;
  }

  .text-right {
    text-align: left;
    margin-top: 12px;
  }

  .el-dialog {
    width: 95% !important;
  }
}
</style>